const ENParametersHierarchy = {
	"Erro ao buscar hierarquia de parâmetros":"Error on search parameters hierarchy",
	"Hierarquia de parâmetros":"Parameters hierarchy",
	"Não foram encontrados parâmetros para esta pesquisa":"No parameters were found for this search",
	"O valor do parâmetro é requerido":"The parameter value is required",
	"Parâmetros salvos com sucesso":"Parameter successfully saved",
	"Erro ao salvar parâmetros":"Error on save parameter",
	"Inserir valor default":"Insert default value"
};

export default ENParametersHierarchy;
